import styled from 'styled-components'

export default styled.div({
    display: 'flex',
    marginLeft: '-5px',
    marginRight: '-5px',
})



// WEBPACK FOOTER //
// ./src/components/elasticGrid.js